import { FEATURE_FLAGS } from '../../../featureFlags';
import OrdersList from './OrdersList.vue';
import OrderDetails from './OrderDetails.vue';

const commonMeta = {
  featureFlag: FEATURE_FLAGS.SERVICE_ORDERS,
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: 'orders',
    name: 'orders_list',
    component: OrdersList,
    meta: commonMeta,
  },
  {
    path: 'orders/:orderId',
    name: 'order_details',
    component: OrderDetails,
    meta: commonMeta,
  },
];

export default routes;
